<!--
  ScreenfullComponent 组件
  作用：本来用于实现全屏切换功能，但现在功能已移除，只保留了容器结构。
  语法说明：
    - <template> 区块写页面结构。
    - <script> 区块写 JS 逻辑。
    - <style scoped> 区块写样式，scoped 表示只作用于本组件。
  文件关系：
    - 这个组件被 WisdomCommunityScreen.vue 通过 <screenfull-component /> 标签引用。
    - 目前没有实际功能，只是一个空壳。
-->
<!--
  <template> 是 Vue 单文件组件（.vue 文件）特有的标签，用于写页面结构。
  普通 HTML+JS 前端开发，结构、逻辑、样式通常分散在不同文件里（.html、.js、.css）。
  Vue 框架则把结构（<template>）、逻辑（<script>）、样式（<style>）都写在一个 .vue 文件里，方便组件化开发和维护。
  这样每个功能模块都可以独立、复用，开发大型项目更高效。
-->
<template>
  <!-- screenfull-container 是全屏按钮的外层容器，当前没有内容 -->
  <div class="screenfull-container">
    <!--
      说明：因为这个 div 里面没有任何内容（也没有设置宽高），
      所以它的宽度和高度都变成了0，页面上看不到任何东西。
      只有加内容（如文字、图片、按钮）或用CSS手动设置宽高时，这个容器才会显示出来。
    -->
    <!-- 全屏功能已移除，这里本来可以放按钮或图标 -->
  </div>
</template>

<script>
// 这是 Vue 3 单文件组件的 JS 逻辑部分
export default {
  name: 'ScreenfullComponent', // 组件名称，便于调试和引用
  setup() { // 组合式 API 的入口函数
    // 这里本来可以写全屏切换的逻辑，现在功能已移除
    return {} // 返回给模板用的数据和方法，这里为空
  }
}
</script>

<style scoped>
/*
  .screenfull-container 是全屏按钮的外层容器
  display: inline-block; 让它表现得像一个“行内块元素”
  
  块元素（block element）：在页面上会独占一行，宽度默认撑满父容器，高度由内容决定。
    常见如 div、p、h1~h6、ul、li 等。div 默认 display: block，会自动换行，能设置宽高。
  行内元素（inline element）：只占内容本身宽度，不会换行，如 span、a、img。
    span 默认 display: inline，在一行内顺序排列，不能设置宽高（width/height 无效），但能设置字体、颜色、内外边距。
  行内块元素（inline-block）：既能和其他内容并排，又能设置宽高。
    是通过 CSS 的 display: inline-block; 把元素变成“能并排的盒子”，既有块元素的特性（能设置宽高），又有行内元素的特性（能并排）。
  这里用 inline-block，是让按钮既能设置宽高，又能和其他内容在一行显示。
*/
.screenfull-container {
  display: inline-block;
}
</style>